import { render, staticRenderFns } from "./TaskListComponent.vue?vue&type=template&id=5759cf2e"
import script from "./TaskListComponent.vue?vue&type=script&lang=js"
export * from "./TaskListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports